import { Button, Card, Dialog, Typography } from '@material-ui/core'
import Slide from '@material-ui/core/Slide'
import classNames from 'classnames'
import * as React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { isAndroid, isIOS, isMobile } from 'react-device-detect'
import { RouteComponentProps, withRouter } from 'react-router'
import ReactSVG from 'react-svg'

import { appStoreLink, googlePlayLink } from 'config/appLinks'
import { sendDownloadEmail } from 'services/email'
import SnackbarService from 'services/snackbars'
import { modalDeviceType } from 'services/utils'

import AppleIcon from 'assets/img/apple.svg'
import BlueBalloon from 'assets/img/balloons/blue_balloon.svg'
import PurpleBalloon from 'assets/img/balloons/purple_balloon.svg'
import YellowBalloon from 'assets/img/balloons/yellow_balloon.svg'
import CrossIcon from 'assets/img/cross.svg'
import GooglePlayIcon from 'assets/img/googleplay.svg'
import LinkIcon from 'assets/img/link.svg'

import './style.scss'

const Transition = props => (
  <Slide direction="up" {...props} timeout={{ enter: 500, exit: 300 }} />
)

enum Page {
  thisDevice = 'this-device',
  anotherDevice = 'another-device'
}

interface IProps extends RouteComponentProps {
  user: any
  open: boolean
  onSubmit?: () => void
  onClose: () => void
}

interface IState {
  page: Page
}

class GameInstallationModalBase extends React.Component<IProps, IState> {
  state: IState = {
    page: isMobile ? Page.thisDevice : Page.anotherDevice
  }

  onBackBrowserBtnEvent = event => {
    event.preventDefault()

    const { onClose } = this.props
    onClose()

    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)
  }

  fullScreen = () => true

  goBackAction = () => {
    const { page } = this.state
    const { onClose } = this.props

    if (page === Page.thisDevice) {
      onClose()
    } else {
      this.setState({ page: Page.thisDevice })
    }
  }

  deviceLink = () => {
    if (isIOS) {
      return appStoreLink
    } else if (isAndroid) {
      return googlePlayLink
    } else {
      return ''
    }
  }

  sendDownloadEmail = (link: string) => {
    const { user } = this.props
    sendDownloadEmail(user.email, link, user.full_name)
  }

  renderThisDeviceLinks = () => {
    return (
      <>
        <Button
          className="btn download-btn"
          onClick={() => window.open(this.deviceLink())}
        >
          INSTALL ON THIS DEVICE
        </Button>
        <Button
          className="btn download-btn white-btn"
          onClick={() => this.setState({ page: Page.anotherDevice })}
        >
          INSTALL ON ANOTHER DEVICE
        </Button>
      </>
    )
  }

  onSend = (link: string) => () => {
    this.sendDownloadEmail(link)
    SnackbarService.showSnackbar('We sent a link to your email', 'info')
  }

  renderAnotherDeviceLinks = () => {
    return (
      <>
        <div className="send-emails">
          <Button
            className="send-email-btn"
            onClick={this.onSend(appStoreLink)}
          >
            <ReactSVG className="send-email-img apple-icon" src={AppleIcon} />
            <div className="info">
              <Typography className="small">send iOS link</Typography>
              <Typography className="text">By Email</Typography>
            </div>
          </Button>
          <Button
            className="send-email-btn"
            onClick={this.onSend(googlePlayLink)}
          >
            <ReactSVG
              className="send-email-img google-play-icon"
              src={GooglePlayIcon}
            />
            <div className="info">
              <Typography className="small">send Android link</Typography>
              <Typography className="text">By Email</Typography>
            </div>
          </Button>
        </div>
        <div className="copy-links">
          <div className="copy">
            <Typography className="small">copy app store link</Typography>
            <CopyToClipboard
              text={appStoreLink}
              onCopy={() =>
                SnackbarService.showSnackbar('Link copied to clipboard', 'info')
              }
            >
              <Button className="copy-btn">
                <div className="copy-container">
                  <div className="link-icon-container">
                    <ReactSVG className="link-icon" src={LinkIcon} />
                  </div>
                  <Typography className="link">{appStoreLink}</Typography>
                </div>
              </Button>
            </CopyToClipboard>
          </div>

          <div className="copy">
            <Typography className="small">copy google play link</Typography>
            <CopyToClipboard
              text={googlePlayLink}
              onCopy={() =>
                SnackbarService.showSnackbar('Link copied to clipboard', 'info')
              }
            >
              <Button className="copy-btn">
                <div className="copy-container">
                  <div className="link-icon-container">
                    <ReactSVG className="link-icon" src={LinkIcon} />
                  </div>
                  <Typography className="link">{googlePlayLink}</Typography>
                </div>
              </Button>
            </CopyToClipboard>
          </div>
        </div>
      </>
    )
  }

  downlaods = () => {
    const { page } = this.state
    switch (page) {
      case Page.thisDevice:
        return this.renderThisDeviceLinks()
      case Page.anotherDevice:
        return this.renderAnotherDeviceLinks()
      default:
        return null
    }
  }

  handleClose = () => {
    window.removeEventListener('popstate', this.onBackBrowserBtnEvent)

    window.history.back()

    this.props.onClose()
  }

  render() {
    const { open } = this.props
    const { page } = this.state
    const modalType = modalDeviceType()

    return (
      <Dialog
        fullScreen={this.fullScreen()}
        open={open}
        onEnter={() => {
          // this.setState({
          //   page: isMobile ? Page.thisDevice : Page.anotherDevice
          // })
          window.history.pushState(null, '', window.location.pathname)
          window.addEventListener('popstate', this.onBackBrowserBtnEvent)
        }}
        onClose={this.handleClose}
        className="dialog"
        PaperProps={{
          className: `dialog-modal-paper dialog-modal-paper--games-installation dialog-modal-paper--${modalType}`
        }}
        {...(isMobile &&
          ({
            TransitionComponent: Transition
          } as any))}
      >
        <div className="instruction-page">
          {/* <Header
            title="Game Installation"
            smallHeader={true}
            oneRow={true}
            goBackAction={this.goBackAction}
            disableBackButton={false}
          /> */}
          <div className="mobile-container">
            <div className="evaluation-game instruction">
              <div className="content">
                <Card className="card">
                  <Typography className="card-title">
                    Evaluation Game
                  </Typography>
                  <Typography className="card-text">
                    The GiantLeap Evaluation Game is a separate app available
                    for iOS and Android devices. Install the app and play the
                    games together with your child
                  </Typography>
                  <div className={classNames('downloads', page)}>
                    {this.downlaods()}
                  </div>
                </Card>
                <div className="next-btn-container">
                  <Button onClick={this.handleClose} className="btn next-btn">
                    Done
                  </Button>
                </div>
              </div>
              <div className="balloons">
                <ReactSVG src={BlueBalloon} className="balloon blue-balloon" />
                <ReactSVG
                  src={YellowBalloon}
                  className="balloon yellow-balloon"
                />
                <ReactSVG
                  src={PurpleBalloon}
                  className="balloon purple-balloon"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="cross-icon" onClick={this.handleClose}>
          <ReactSVG src={CrossIcon} />
        </div>
      </Dialog>
    )
  }
}
export const GameInstallationModal = withRouter(GameInstallationModalBase)



// WEBPACK FOOTER //
// ./src/components/GameInstallationModal/index.tsx